module.exports = __webpack_public_path__ + "img/mj6.f12b6f63.png";